import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { CvprmModa } from 'src/app/models/api/comercial/cvprm-moda';

@Injectable({
  providedIn: 'root'
})
export class ApiCvprmModaService {
  private baseUrl = 'CVPRMModa';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<CvprmModa[]>('');
  }
}
